// @mui material components
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Google Analytics
import ReactGA from "react-ga4";

function HiddenPlacesEurope() {
  ReactGA.send({
    hitType: "pageview",
    page: "/",
    title: "HiddenLocations",
  });

  // Device detection for conditional CTA
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return (
    <>
      {/* Keep navbar outside the Grid so it remains full width */}
      <MKBox position="fixed" top="0.5rem" width="100%" zIndex={1300}>
        <DefaultNavbar
          routes={routes}
          action={{
            type: "external",
            route: "https://play.google.com/store/apps/details?id=com.naxx.tripenhancer.free",
            label: "Get TripEnhancer",
            color: "info",
          }}
        />
      </MKBox>

      <Container>
        <Grid container spacing={3} alignItems="center">
          {/* Hero/Lead Magnet Card */}
          <Grid
            item
            xs={12}
            sm={11}
            md={9}
            lg={8}
            xl={7}
            ml={{ xs: "auto", lg: 6 }}
            mr={{ xs: "auto", lg: 6 }}
          >
            <MKBox
              bgColor="white"
              borderRadius="xl"
              shadow="xl"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              mt={{ xs: 20, sm: 18, md: 20 }}
              mb={{ xs: 6, sm: 8, md: 10 }}
              mx={{ xs: 2, sm: 4, md: 6 }}
              sx={{
                border: "1px solid #e0e0e0",
                boxShadow: 6,
                padding: { xs: 2, sm: 4, md: 6 },
                minHeight: 220,
                maxWidth: "100%",
              }}
            >
              <MKBox
                variant="gradient"
                bgColor="info"
                coloredShadow="info"
                borderRadius="lg"
                p={3}
                mx={2}
                mt={-4}
                sx={{
                  boxShadow: 3,
                  textAlign: "center",
                }}
              >
                <MKTypography variant="h2" color="white" sx={{ fontWeight: 700 }}>
                  Europe is full of places tourists never discover.
                </MKTypography>
                <MKTypography variant="h5" color="white" mt={1}>
                  Discover Europe’s Hidden Gems
                </MKTypography>
              </MKBox>

              <MKBox p={3} sx={{ textAlign: "center" }}>
                <MKTypography
                  variant="body1"
                  color="text"
                  mb={2}
                  sx={{ fontSize: { xs: "1.08rem", sm: "1.18rem" } }}
                >
                  Unlock secret viewpoints, quiet valleys, remote villages, and historic
                  ruins—hand‑picked for real explorers. No tourist traps. No crowds. Just authentic
                  adventure.
                </MKTypography>
                <MKTypography variant="body2" color="text" mb={2}>
                  <b>TripEnhancer</b> is your personal guide to Europe’s best-kept secrets. Start
                  exploring today!
                </MKTypography>
                <MKBox mt={4} mb={2}>
                  {isIOS ? (
                    <MKBox>
                      <MKTypography variant="body1" color="info" mb={1}>
                        iPhone user? Join our waitlist!
                      </MKTypography>
                      <MKBox
                        component="a"
                        href="mailto:tripenhancerapp@gmail.com?cc=bart.caris@telenet.be&subject=TripEnhancer%20iPhone%20Waitlist"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          textDecoration: "none",
                        }}
                      >
                        <MKBox
                          bgColor="info"
                          color="white"
                          borderRadius="md"
                          px={4}
                          py={1.5}
                          sx={{
                            fontWeight: 600,
                            fontSize: "1.1rem",
                            boxShadow: 2,
                            display: "inline-block",
                            cursor: "pointer",
                          }}
                        >
                          Join iPhone Waitlist
                        </MKBox>
                      </MKBox>
                    </MKBox>
                  ) : (
                    <MKBox
                      component="a"
                      href="https://play.google.com/store/apps/details?id=com.naxx.tripenhancer.free"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textDecoration: "none",
                      }}
                    >
                      <MKBox
                        bgColor="success"
                        color="white"
                        borderRadius="md"
                        px={5}
                        py={1.7}
                        sx={{
                          fontWeight: 700,
                          fontSize: "1.2rem",
                          boxShadow: 3,
                          display: "inline-block",
                          cursor: "pointer",
                        }}
                      >
                        Explore with TripEnhancer
                      </MKBox>
                    </MKBox>
                  )}
                </MKBox>
                {/*                <MKTypography variant="caption" color="text" mt={2}>
                  No spam. We’ll notify you as soon as TripEnhancer is available for iPhone.
                </MKTypography>*/}
              </MKBox>
            </MKBox>
          </Grid>

          {/* Full row inside the same container — responsive map */}
          <Grid item xs={12}>
            <MKBox
              borderRadius="lg"
              overflow="hidden"
              sx={{
                width: "100%",
                aspectRatio: { xs: "3 / 4", sm: "4 / 3", md: "16 / 9" },
                minHeight: 320,
                maxHeight: 720,
                boxShadow: (theme) => theme.shadows[3],
                mt: { xs: 2, sm: 4 },
              }}
            >
              <iframe
                src="https://www.google.com/maps/d/u/0/embed?mid=1tq1Q8hM6tPd_F4Qo1aASO3TkkbCtWF8&ehbc=2E312F"
                width="1280"
                height="960"
                style={{ border: 0, width: "100%", height: "100%" }}
                allowFullScreen=""
                loading="lazy"
                title="Hidden Places Map"
              ></iframe>
            </MKBox>
          </Grid>
        </Grid>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </Container>
    </>
  );
}

export default HiddenPlacesEurope;
